import type { PaymentTransaction } from 'types/paymentTypes';

export const createPaymentTransaction = (): PaymentTransaction => ({
  currency: 'USD',
  amount: 0,
});

export const createPaymentTransactionUSDMock = (): PaymentTransaction => ({
  currency: 'USD',
  amount: 320,
});

export const createPaymentTransactionBYNMock = (): PaymentTransaction => ({
  currency: 'BYN',
  amount: 680,
});
